import { FC } from "react"
import Button from "@mui/material/Button"
import { EventContactInfoDto } from "@app/data/tribeSwaggerApi"

interface Props { formik: any }

const FIELDS = [
  { key: "TELEGRAM", label: "Telegram", placeholder: "@username или t.me/username" },
  { key: "WHATSAPP", label: "WhatsApp",  placeholder: "+7 999 123-45-67" },
  { key: "PHONE",    label: "Телефон",   placeholder: "+7 999 123-45-67" },
]

const inputStyle = {
  width: "100%", padding: "10px 14px", borderRadius: 8,
  background: "var(--Schemes--Surface-Container-Low, #1e1e24)",
  border: "1px solid var(--borders, #2a2a38)",
  color: "var(--primary-text, #e4e4f0)", fontSize: 14, outline: "none",
}
const labelStyle = { fontSize: 13, color: "var(--secondary-text, #8a8aaa)", marginBottom: 4, display: "block" }

const ContactsTabPanel: FC<Props> = ({ formik }) => {
  const contacts: EventContactInfoDto[] = formik.values.contact_info ?? []

  const get = (type: string) => contacts.find(c => c.contact_type === type)?.contact ?? ""

  const set = (type: string, value: string) => {
    const next = contacts.filter(c => c.contact_type !== type)
    if (value.trim()) next.push({ contact: value.trim(), contact_type: type as any })
    formik.setFieldValue("contact_info", next)
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20, maxWidth: 400 }}>
      <p style={{ fontSize: 13, color: "var(--secondary-text, #8a8aaa)", margin: 0 }}>
        Контактные данные видны участникам события после одобрения заявки.
      </p>
      {FIELDS.map(f => (
        <div key={f.key}>
          <label style={labelStyle}>{f.label}</label>
          <input
            style={inputStyle}
            type="text"
            placeholder={f.placeholder}
            value={get(f.key)}
            onChange={e => set(f.key, e.target.value)}
          />
        </div>
      ))}
    </div>
  )
}

export default ContactsTabPanel
